<template>
  <div class="my-1 card">
    <h4 class="my-0 py-2 card-header text-info">
      Select Client and Document Type
    </h4>
    <div class="card-body">
      <div class="form-group">
        <label for="exampleInputEmail1">Document Type</label>
        <select
          v-model="documenttype"
          class="form-control w-50"
          id="lawfirmList"
          :disabled="createAgainMode"
          @change="selectedDocumenttype(documenttype)"
        >
          <option
            v-for="ser in masterData.documentType"
            v-bind:key="ser.id"
            v-bind:value="ser.title"
          >
            {{ ser.title }}
          </option>
        </select>
        <small id="lawfirmHelp" class="form-text text-muted"
          >Please select the Document Type that this project corresponds
          to</small
        >
      </div>
      <div class="form-group">
        <label for=""
          >Client Name
          <span v-if="this.documenttype.toLowerCase() !== 'sow amendments'">
            <button
              class="btn btn-info mx-1"
              size="sm"
              title="Click here to continue as new
              client"
              style="font-size: 10px"
              v-if="!isManual"
              @click="toggleClient((isManual = !isManual))"
              v-bind:icon="['fa', 'toggle-off']"
            >
              New Client
            </button>
            <div class="arrow bounce" v-if="showarrow && !isManual">
              <font-awesome-icon
                :icon="['fas', 'arrow-left']"
              ></font-awesome-icon>
            </div>
            <button
              class="btn btn-danger mx-1"
              size="sm"
              style="font-size: 10px"
              v-if="isManual"
              title="Cancel"
              @click="toggleClient((isManual = !isManual))"
              v-bind:icon="['fa', 'toggle-on']"
            >
              Cancel
            </button>
          </span>
        </label>
        <multiselect
          v-model="client"
          label="name"
          track-by="name"
          v-if="!isManual"
          :placeholder="'Search Client'"
          class="w-50"
          open-direction="bottom"
          :options="clients"
          :searchable="true"
          :loading="isLoading"
          @search-change="getClients"
          onpaste="return false;"
        >
          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <span class="option__title">{{
                props.option.name ? props.option.name : props.option.label
              }}</span
              ><small
                class="option__small"
                v-if="props.option.companyId && props.option.companyId !== '0'"
              >
                &nbsp;-&nbsp;(Company Id:{{ props.option.companyId }})</small
              >
            </div>
          </template>
          <template>
            <span slot="noResult" style="font-size: 14px"
              >No Clients found. Click on New Client to continue as new
              client</span
            >
          </template>
        </multiselect>
        <input
          class="form-control w-50"
          type="text"
          v-if="isManual"
          v-model="newClient"
          placeholder="Enter the Client name"
        />
      </div>
      <div></div>
      <div
        class="form-group"
        v-if="
          (isManual ||
            hascountrydetails == false ||
            hasworkspacedetails == false) &&
          this.documenttype.toLowerCase() !== 'sow amendments'
        "
      >
        <label for="exampleInputEmail1">Country</label>
        <select
          v-model="country"
          class="form-control w-50"
          id="incidentTypeList"
          aria-describedby="incidentTypeHelp"
        >
          <option
            v-for="ser in masterData.countries"
            v-bind:key="ser.id"
            v-bind:value="ser.slug"
          >
            {{ ser.title }}
          </option>
        </select>
        <small v-if="isManual" class="form-text text-muted"
          >Please select Country</small
        >
      </div>
      <button class="btn btn-info mx-2" @click="gonext" :disabled="nextable">
        <div
          v-if="dataloading"
          class="spinner-border text-white fileuploading"
          style="width: 1rem; height: 1rem"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
        Next
        <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
      </button>
    </div>
  </div>
</template>

<script>
import serviceProxy from "../services/index";
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect },
  created() {
    var that = this;
    that.$root.$emit("removestage");
    if (this.$store.getters.selectedManualClient) {
      this.newClient = this.$store.getters.selectedManualClient;
      this.country = this.$store.getters.selectedCountry;
      this.isManual = true;
    }
    if (that.$store.getters.selectedDocumenttype || this.createAgainMode) {
      let selectedDocumenttype = this.createAgainMode
        ? this.$store.getters.selectedDocumenttype
          ? this.$store.getters.selectedDocumenttype
          : "select-template"
        : this.$store.getters.selectedDocumenttype;

      this.documenttype = selectedDocumenttype;
      this.client = that.$store.getters.selectedClient;
      this.country = this.$store.getters.selectedCountry;
    }
    if (!that.$store.getters.hasMasterData) {
      this.getMasterData();
    } else {
      let that = this;
      that.$root.$emit("done");
      let mrdata = that.$store.getters.masterData;
      that.masterData.countries = mrdata.countries;
      that.masterData.documentType = mrdata.documents;
      that.masterData.subofferingType = mrdata.subofferingType;
      if (that.documenttype.toLowerCase() == "sow") {
        that.IsBusinessType = true;
        that.masterData.subofferingType;
      }
    }
  },
  data() {
    return {
      countryId: parseInt(process.env.VUE_APP_countryId),
      amendmentMode: this.$store.getters.amendmentMode,
      newMdrRenewal: this.$store.getters.newMdrRenewal,
      dataloading: false,
      isManual: false,
      selectedManualClient: "",
      showarrow: false,
      newClient: "",
      masterData: {
        country: [],
        documentType: [],
        businessType: [],
      },
      IsBusinessType: false,
      hasworkspacedetails: null,
      isTaggable: false,
      documenttype: "",
      subofferingType: "",
      country: null,
      client: null,
      clients: [],
      isLoading: false,
      createAgainMode: this.$store.getters.createAgainMode,
      hascountrydetails: null,
    };
  },
  computed: {
    nextable() {
      if (
        this.documenttype.toLowerCase() == "sow amendments" ||
        this.documenttype.toLowerCase() == "mdr renewals"
      ) {
        return !(
          this.documenttype &&
          (this.client
            ? this.client.name
              ? this.client.name
              : ""
            : "" || this.newClient)
        );
      } else {
        return !(
          this.documenttype &&
          this.country &&
          (this.client
            ? this.client.name
              ? this.client.name
              : ""
            : "" || this.newClient)
        );
      }
    },
  },
  methods: {
    gonext: function () {
      var that = this;
      let mrdata = that.$store.getters.masterData;
      if (!this.amendmentMode) {
        if (this.documenttype != this.$store.getters.selectedDocumenttype) {
          that.$store.commit("init");
        }
      }
      if (this.isManual) {
        this.selectedManualClient = this.newClient;
        const Client = {
          name: this.selectedManualClient,
          companyId: "0",
          workspaceIds: {},
        };
        this.client = Client;
      } else {
        this.selectedManualClient = "";
        this.client.clientaddressline = this.client.address;
        this.client.clientaddresscity = this.client.city;
        this.client.clientaddressstate = this.client.state;
        this.client.clientaddresszip = this.client.zip;
        this.client.clientcontactnumber = this.client.phone;
      }
      this.$store.commit("settings", {
        documenttype: this.documenttype,
        manualclient: this.selectedManualClient,
        isNewClient: this.isManual,
        client: this.client,
        country: this.country,
        subofferingType: this.$store.getters.selectedSubofferingType,
        lawfirm: this.$store.getters.selectedLawfirm,
        incidentType: this.$store.getters.selectedIncidentType,
      });

      let documentType;
      let type = this.documenttype.toLowerCase();
      switch (type) {
        case "sow":
          documentType = "select-template";
          break;
        case "mdr renewals":
        case "sow amendments":
          documentType = "search-client";
          break;
        case "baa":
          documentType = "baa-template";
          break;
        case "nda":
          documentType = "nda-template";
          break;
        case "baa & nda":
          documentType = "baa-nda-template";
          break;
        case "baanda":
          documentType = "baa-nda-template";
          break;
        default:
          documentType = "select-template";
          break;
      }

      this.$router.push({ path: documentType });
    },
    toggleClient() {
      this.client = "";
      this.newClient = "";
      this.hasworkspacedetails = true;
      this.hascountrydetails = true;
      this.showarrow = false;
    },
    formatCountry(countryval) {
      let countries = [
        { Code: "US", Title: "USA- LE001" },
        { Code: "USA", Title: "USA- LE001" },
        { Code: "United States", Title: "USA- LE001" },
        { Code: "Canada", Title: "Canada- LE004" },
        { Code: "India", Title: "India- LE003" },
      ];
      return _.filter(countries, (mr) => mr.Code.toLowerCase() === countryval.toLowerCase());
    },
    getMasterData() {
      let that = this;
      that.$root.$emit("progress");
      serviceProxy.master
        .getMasterData(this.$store.getters.token)
        .then((data) => {
          let mrdata = data.data.data;
          console.log(mrdata);
          let services = _.filter(mrdata.services, (mr) => mr.isActive);
          let lawfirms = _.filter(mrdata.lawfirms, (mr) => mr.isActive);
          let incidentTypes = _.filter(
            mrdata.incidentTypes,
            (mr) => mr.isActive
          );
          let documents = _.filter(mrdata.documentTypes, (mr) => mr.isActive);
          let countries = _.filter(mrdata.countries, (mr) => mr.isActive);
          let authorities = _.filter(mrdata.authorities, (mr) => mr.isActive);
          let subofferingTypes = _.filter(
            mrdata.subofferingTypes,
            (mr) => mr.isActive
          );
          that.masterData.subofferingTypes = _.clone(subofferingTypes);
          that.masterData.countries = _.clone(countries);
          that.masterData.documentType = _.clone(documents);
          let masterData = {
            services,
            lawfirms,
            incidentTypes,
            documents,
            countries,
            subofferingTypes,
            authorities,
          };
          that.$store.commit("populateMR", masterData);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "Data Fetched",
            message: "Fetched the MasterData",
          });
        })
        .catch((e) => {
          //console.log(e);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "OOPS",
            message: "Error in fetching the data",
          });
        });
    },
    selectedDocumenttype(documenttype) {
      let that = this;
      let selecteddocType = documenttype.toLowerCase();
      let documentTypes = that.masterData.documentType;
      this.client = null;
      this.clients = [];
      this.isManual = false;
    },
    getClients(searchText) {
      if (searchText.length > 2) {
        this.isLoading = true;
        if (
          this.documenttype.toLowerCase() != "sow amendments" &&
          this.documenttype.toLowerCase() != "mdr renewals"
        ) {
          serviceProxy.projects
            .getClients(this.$store.getters.token, searchText)
            .then((response) => {
              this.isLoading = false;
              this.clients = response.data.data;
              if (this.clients.length > 0) {
                this.showarrow = false;
              } else {
                this.showarrow = true;
              }
            });
        } else {
          // if (this.documenttype.toLowerCase() == "sow amendments") {
          //   this.isTaggable = false;
          // } else if (this.documenttype.toLowerCase() == "mdr renewals") {
          //   this.isTaggable = true;
          // }
          serviceProxy.sow
            .getAmendmentClients(this.$store.getters.token, searchText)
            .then((response) => {
              let amenClients = [];
              _.forEach(response.data.data, (melement) => {
                amenClients.push({
                  name: melement,
                  companyId: "0",
                  workspaceIds: {},
                });
              });
              this.clients = amenClients;
              this.isLoading = false;
            });
        }
      } else {
        this.clients = [];
      }
    },
  },
  watch: {
    subofferingType: function (newIncidentType, oldIncidentType) {
      if (!this.createAgainMode && oldIncidentType) {
        this.$store.commit("mdrtemplateconfig", null);
      }
    },
    client(c, oldclient) {
      //c.workspaceId = 28333565;
      if (!this.createAgainMode && oldclient) {
        this.$store.commit("baatemplateconfig", null);
        this.$store.commit("ndatemplateconfig", null);
        this.$store.commit("mastertemplateconfig", null);
        this.$store.commit("templateconfig", null);
        this.$store.commit("selectedClientDetails", {});
        this.$store.commit("setProjectDetails", null);
      } else if (!oldclient) {
        this.$store.commit("selectedClientDetails", {});
        this.$store.commit("setProjectDetails", null);
      }
      if (c ? c.companyId != "0" : false) {
        this.selectedManualClient = "";
        this.isManual = false;
      } else {
        this.$store.commit("selectedClientDetails", null);
        this.$store.commit("setProjectDetails", null);
      }
      if (
        c != null &&
        !this.isManual &&
        this.documenttype.toLowerCase() !== "sow amendments" &&
        this.documenttype.toLowerCase() !== "mdr renewals"
      ) {
        let workspaceKey = Object.keys(c.workspaceIds).find(
          (key) => c.workspaceIds[key] !== null
        );
        const workspaceId = c.workspaceIds.ir
          ? c.workspaceIds.ir
          : c.workspaceIds.bec
          ? c.workspaceIds.bec
          : c.workspaceIds[workspaceKey]
          ? c.workspaceIds[workspaceKey]
          : null;
        if (workspaceId !== null) {
          this.dataloading = true;
          this.hasworkspacedetails = true;
          serviceProxy.projects
            .getProjectDetails(this.$store.getters.token, workspaceId)
            .then((response) => {
              if (response.data.data) {
                let that = this;
                this.country = this.$store.getters.selectedCountry
                  ? this.$store.getters.selectedCountry
                  : "";
                var countrydetails = _.find(
                  response.data.data.custom_field_values,
                  (selser) => selser.custom_field_id === this.countryId
                );
                let mrdata = that.$store.getters.masterData;
                if (countrydetails) {
                  let country = _.filter(
                    mrdata.countries,
                    (mr) => mr.title === countrydetails.display_value
                  );
                  this.country = country[0].slug;
                  this.hascountrydetails = true;
                } else {
                  this.hascountrydetails = false;
                }
                this.dataloading = false;
                this.$store.commit("setProjectDetails", response.data.data);
              }
            });
        } else {
          let mrdata = this.$store.getters.masterData;
          let country = _.filter(
            mrdata.countries,
            (mr) => mr.title === c.country
          );
          if (country.length > 0) {
            this.country = country[0].slug;
          } else {
            let countryObj = this.formatCountry(c.country);
            if (countryObj.length > 0) {
              let country = _.filter(
                mrdata.countries,
                (mr) => mr.title === countryObj[0].Title
              );
              this.country = country[0].slug;
              this.hascountrydetails = true;
            } else {
              this.hascountrydetails = false;
            }
          }
          //this.hasworkspacedetails = false;
        }
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.arrow {
  text-align: center;
  margin: 0 0 0 25px;
  display: inline-block;
}
.bounce {
  -moz-animation: bounce 2s infinite;
  -webkit-animation: bounce 2s infinite;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateX(0);
  }
  40% {
    transform: translateX(-30px);
  }
  60% {
    transform: translateX(-15px);
  }
}
</style>